import * as React from 'react';
import { connect } from 'react-redux';
import PolicyDetails from './../PersonalInsurance/PolicyDetails/PolicyDetails';
import { getRiskItemType, hideMobileProfile, setSelectedCover, setSelectedQuotedCover } from '../../actions/profileActions';
import PersonalInsuranceCard from './PersonalInsuranceCard';
import PersonalInsuranceQuotedCoverCard from './PersonalInsuranceQuotedCoverCard';
import { PREMIUM_BREAKDOWN, DASHBOARD, POLICY_DETAILS, QUOTE_DETAILS } from '../../routes/routes';
import KPBreadCrumb from '../KPBreadCrumb/KPBreadCrumb';
import { navigateTo } from '../../actions/navigationActions';
import { POLICY_COVER_ITEM, QUOTED_COVER_ITEM } from '../../constants/constants';
import { toggleHasError, toggleSelfInspectPhotos } from '../../actions/selfInspectActions';
import QuoteDetails from './QuoteDetails/QuoteDetails';
import { PRODUCT_TYPES } from '../../constants/products';
import { RISK_ITEM_TYPES } from '../../constants/riskItems';
import { showModalCalculatorBroke } from '../../actions/salesModalActions';

class PersonalInsurance extends React.Component<any, any> {

    constructor(props) {
        super(props);

        this.state = {
            coverItems: []
        };

        this.getCoverItems = this.getCoverItems.bind(this);
        this.handleRedirect = this.handleRedirect.bind(this);
        this.handleCoverRedirect = this.handleCoverRedirect.bind(this);
    }

    componentDidMount() {
        this.props.dispatchHideProfile();
        this.getCoverItems();
    }

    handleRedirect(destination) {
        this.props.redirectTo(destination);
        this.props.dispatchToggleHasError(false);
        this.props.dispatchToggleSelfInspectPhotos(false);
    }

    handleCoverRedirect(itemType) {
        const isMobile = window.innerWidth <= 975;
        if (isMobile) {
            let destination = (itemType === POLICY_COVER_ITEM) ? POLICY_DETAILS : QUOTE_DETAILS;
            this.props.redirectTo(destination);
        }
    }

    quotedItemSupported(riskItemType) {
        let supportedItems = [RISK_ITEM_TYPES.Cars.Id, RISK_ITEM_TYPES.Motorbikes.Id];
        return (supportedItems.filter(x => x === riskItemType).length > 0);
    }

    async getCoverItems() {
        let coverItems: any[] = [];

        if (this.props.profile.selectedPersonalPolicy !== undefined && this.props.profile.selectedPersonalPolicy.covers !== undefined) {
            this.props.profile.selectedPersonalPolicy.covers
                .filter(cover => cover.isMainline === true)
                .forEach((cover) => {
                    coverItems.push({
                        type: POLICY_COVER_ITEM,
                        item: cover,
                        productName: cover.productName,
                        yaml: <div>
                                <PersonalInsuranceCard id={cover.id}
                                    alertCount="0"
                                    productNumber={cover.product}
                                    headerText={cover.productName}
                                    bodyText={cover.riskItems[0].description}
                                    premium={cover.riskItems[0].premium}
                                    type={cover.riskItems[0].type}
                                    image={cover.image}
                                    hasError={cover.riskItems[0].hasError}
                                    onClickHandler={this.handleCoverRedirect}
                                    />
                                </div>
                        }
                    );
                });
        }

        if (this.props.profile.quotedFutureItems) {
            this.props.profile.quotedFutureItems.forEach(item => {
                let quoteCover = item.quoteCovers.filter(x => x.product.productType == PRODUCT_TYPES.PersonalLines && this.quotedItemSupported(x.product.riskItemType))[0];
                let riskItemType = this.props.dispatchAction(getRiskItemType(quoteCover.product.riskItemType));
                    coverItems.push({
                        type: QUOTED_COVER_ITEM,
                        item: item,
                        productName: riskItemType?.Name ?? '',
                        yaml: <div>
                                <PersonalInsuranceQuotedCoverCard id={item.id}
                                    alertCount="0"
                                    productNumber={quoteCover.product.productType}
                                    headerText={riskItemType?.Name ?? ''}
                                    bodyText={item.quoteRiskItem.description}
                                    premium={item.grossPremium}
                                    type={item.quoteRiskItem.riskItemType}
                                    image={riskItemType?.Image ?? ''}
                                    hasError={false}
                                    riskItemId={item.quoteRiskItem.quoteRiskItemLinkingId}
                                    onClickHandler={this.handleCoverRedirect}
                                />
                            </div>
                    }
                );
            });
        }
        if (coverItems.length > 0) {
            coverItems = coverItems.sort((a, b) => a.productName.localeCompare(b.productName));
            //Auto select first item
            let coverItem = coverItems[0];
            if (coverItem.type === QUOTED_COVER_ITEM) {
                await this.props.dispatchAction(setSelectedQuotedCover(coverItem.item.id));
            }
            else {
                await this.props.dispatchAction(setSelectedCover(coverItem.item.id));
            }
        }

        this.setState({ coverItems });
    }

    public render() {
        const { profile } = this.props;
        let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }]

        let covers: any = <div></div>;

        covers = this.state.coverItems.map(item => {
            return item.yaml;
        });

        let symbol = this.props.profile.currencySymbol;
        let tmp = this.props.profile.selectedPersonalPolicy.totalPolicyPremium;
        let number = Number(tmp.replace(/((N\$)?)+[R ,]*/g, ''));
        let strNumber = symbol + " " + (new Intl.NumberFormat('en-Uk', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(number));

        let defaultDisplay = <>
            <div id="PersonalInsurance">
                <div className="Personal-insurance">
                    <h3 className="Personal-insurance-title mb-6px">Personal policy</h3>
                    <p className="text-white font-weight-normal line-height-normal mb-8px">Total monthly premium</p>
                    <h3 className="text-white PremiumAmount mb-0px">{this.props.profile.selectedPersonalPolicy !== undefined && strNumber} pm</h3>
                    <hr className="Stroke" />
                    <div className="row">
                        <div className="col-6 col-lg-6">
                            <p className="pColor mb-5px line-height-normal font-weight-normal">Next debit order</p>
                            <p className="pColor pDetails font-weight-bold"><b>{this.props.profile.selectedPersonalPolicy !== undefined && this.props.profile.selectedPersonalPolicy.nextDebitOrderDate}</b></p>
                        </div>
                        <div className="col-6 col-lg-6">
                            <p className="pColor mb-5px line-height-normal font-weight-normal">Policy no.</p>
                            <p className="pColor pDetails font-weight-bold"><b>{this.props.profile.selectedPersonalPolicy !== undefined && this.props.profile.selectedPersonalPolicy.policyNumber}</b></p>
                        </div>
                    </div>
                </div>
            </div>
            <div id="PremiumBreakdown" className="my-lg-4 my-4">
                <button className="btn btn-outline-red w-100" onClick={() => this.handleRedirect(PREMIUM_BREAKDOWN)}>View premium breakdown</button>
            </div>
            {covers}
        </>

        return (
            <div id="PersonalInsurance" className="container-fluid new-page-margins">
                <div className="new-breadcrumbwrapper breadcrumb-wrapper-capture-conditions-actual"><KPBreadCrumb navList={BreadcrumbDetails} activePage="Personal insurance" /></div>
                {profile.selectedPersonalPolicy !== undefined &&
                    <div className="row new-page-main-row">
                        <div className="col-12 nopa d-none d-sm-none d-md-none d-lg-block d-xl-block">
                            <div className="row noma">
                                <div className="col col-notify-claim">
                                    {defaultDisplay}
                                </div>
                                {(profile.selectedPersonalCoverType === POLICY_COVER_ITEM) &&
                                    <div className="col">
                                        <PolicyDetails />
                                    </div>
                                }
                                {(profile.selectedPersonalCoverType === QUOTED_COVER_ITEM) &&
                                    <div className="col">
                                        <QuoteDetails />
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="col-12 d-block d-sm-block d-md-block d-lg-none d-xl-none nopa" id="PolicyDetailsMobile">
                            <div className="row noma">
                                <div className="col-12 col-notify-claim-nomaxwidth">
                                    {defaultDisplay}
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {
        dispatchHideProfile: () => dispatch(hideMobileProfile()),
        redirectTo: (destination) => dispatch(navigateTo(destination)),
        dispatchToggleSelfInspectPhotos: (value) => dispatch(toggleSelfInspectPhotos(value)),
        dispatchToggleHasError: (value) => dispatch(toggleHasError(value)),
        dispatchAction: (e) => dispatch(e)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(PersonalInsurance);